import {
    INTEGRATION_MAPPING_STATIC_ITEMS,
    type ListBoxItemWithScope,
    type TagWithScope,
} from '#shared/lib/integrations';

type CharacteristicListItem = {
    id: string;
    title: string;
};

export const buildIntegrationMappingAvailableItems = (
    characteristics: CharacteristicListItem[],
    selectedTags: TagWithScope[]
): ListBoxItemWithScope[] => {
    const characteristicsItems: ListBoxItemWithScope[] = characteristics.map(({ id, title }) => {
        return {
            value: id,
            content: title,
            scopeArea: 'characteristic',
        };
    });

    const allItems = [...INTEGRATION_MAPPING_STATIC_ITEMS, ...characteristicsItems];

    return allItems.filter((item) => !selectedTags.some((tag) => tag.key === item.value));
};
